
// src/web/components/chat-messages-page.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/chat-messages-page'
import RightSidePage from './right-side-page.jsx'
import { InfiniteScroll, InviewSensor } from './infinite-scroller'
import Loading from './loading.jsx'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import ChatMessageItem from './chat-message-item.jsx'
import ChatMessageForm from './chat-message-form.jsx'
import chatMessageTheme from './themes/chat-message.css'
import moment from 'moment'
import _ from 'lodash'
import { IconButton } from 'react-toolbox/lib/button';
import ChatRoomSettingsPage from './chat-room-settings-page.jsx';
import GoogleDocDialog from './google-doc-dialog'
import PdfPreviewDialog from './pdf-preview-dialog'
import ChatAlbum from './chat-album'

class ChatMessagesPage extends React.Component {
  state = {
    clientWidth: 0,
    clientHeight: 0,
    viewportHeight: window.innerHeight,
    isMobile: window.innerWidth <= 768,
    isKeyboardVisible: false
  };

  delayScrollBottom = ()=> {
    setTimeout(()=> {
    let div = ReactDOM.findDOMNode(this.scrollDiv)
    if (div) div.scrollTop = div.scrollHeight
  }, 600)
}

  scrollBottom = () => setTimeout(()=> {
    let div = ReactDOM.findDOMNode(this.scrollDiv)
    if (div) div.scrollTop = div.scrollHeight
  }, 200)

  componentDidMount() {
    setTimeout(this.setClientWidth, 200)
    window.addEventListener('resize', this.setClientWidth)
    if (this.state.isMobile) {
      if ('visualViewport' in window) {
        window.visualViewport.addEventListener('resize', this.handleViewportResize);
      }
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('focusin', this.handleFocusIn);
      document.addEventListener('focusout', this.handleFocusOut);
    }
    this.scrollBottom()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setClientWidth)
    if (this.state.isMobile) {
      if ('visualViewport' in window) {
        window.visualViewport.removeEventListener('resize', this.handleViewportResize);
      }
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('focusin', this.handleFocusIn);
      document.removeEventListener('focusout', this.handleFocusOut);
    }
  }

  handleFocusIn = (e) => {
    if (e.target.tagName.toLowerCase() === 'input' || 
        e.target.tagName.toLowerCase() === 'textarea') {
      this.setState({ isKeyboardVisible: true });
      setTimeout(this.scrollBottom, 100);
    }
  }

  handleFocusOut = () => {
    this.setState({ isKeyboardVisible: false });
  }

  handleViewportResize = () => {
    if (this.state.isMobile && window.visualViewport) {
      this.setState({
        viewportHeight: window.visualViewport.height,
        isKeyboardVisible: window.visualViewport.height < window.innerHeight
      });
    }
  };

  handleResize = () => {
    const isMobile = window.innerWidth <= 768;
    this.setState({
      isMobile,
      viewportHeight: window.innerHeight
    });
  };

  setClientWidth = ()=> {
    const element = ReactDOM.findDOMNode(this.component)
    if (element) {
      this.setState({ clientWidth: element.clientWidth, clientHeight: element.clientHeight })
    }
  }

  fetchMessages = ()=> !this.props.isFetching && this.props.fetchMessages(this.props)

  deleteChatMessage = (message_id)=>  this.props.deleteChatMessage(message_id)

  componentDidUpdate(prevProps) {
    const prevIds = prevProps.messageData && _.map(prevProps.messageData.slice(0, 3), (msg)=> msg.message_id) || []
    const propIds = this.props.messageData && _.map(this.props.messageData.slice(0, 10), (msg)=> msg.message_id) || []

    const chatRoomMembers = this.props.chatRoom && this.props.chatRoom.members && this.props.chatRoom.members
    const prevChatRoomMembers = prevProps.chatRoom && prevProps.chatRoom.members && prevProps.chatRoom.members

    if (prevIds.length == 0 && propIds.length > 0 || this.props.chatRoom && !prevProps.chatRoom){
      return this.delayScrollBottom()
    }

    // messageDataの先頭に要素が追加されていたらスクロール位置を末尾に移動する
    _.each(propIds, (id, i)=> {
      if (i > 0 && id == prevIds[0] && !_.some(prevIds, (_id, j)=> propIds[i + j] != prevIds[j])) {
        this.scrollBottom()
        return false
      }
    })

    if(chatRoomMembers && prevChatRoomMembers){
      //メンバーが3名以下になった場合、ダイアログからチャットができないようにする
      //現在のチャットルームのメンバー数が3名以下の場合の条件
      if(chatRoomMembers.length == prevChatRoomMembers.length){
        if(chatRoomMembers.length < 3 && !this.props.ui.individualChatRoom){
          this.props.updateUI({ individualChatRoom: true })
        }
      }
      //現在のチャットルームと過去のチャットルームのメンバー数が異なりなおかつ、member数が3名以上/以下の判定
      if(chatRoomMembers.length != prevChatRoomMembers.length){
        if(chatRoomMembers.length < 3){
          this.props.updateUI({ individualChatRoom: true })
        }else {
          this.props.updateUI({ individualChatRoom: false })
        }
      }
    }
  }

  openPdf = (pdf, open) => {
    this.props.updateUI({ pdf: pdf, openPdf: open })
  }
  closePdf = () => {
    this.props.updateUI({ pdf: false, openPdf: false})
  }

  openDoc = (url, open) => {
    this.props.updateUI({ url: url, openDoc: open  })
  }
  closeDoc = () => {
    this.props.updateUI({ url: false, openDoc: false})
  }

  openAlbum = () => {
    this.props.updateUI({ openAlbum: true })
  }
  closeAlbum = () => {
    this.props.updateUI({ openAlbum: false })
  }

  reactChat = (message_id, reaction_type) => {
    this.props.reactChat(message_id, reaction_type)
  }

  reactionChat = (message, user_id) => {
    const likeExisting = message.likes.some(like => like.user.user_id === user_id);
  
    if (likeExisting) {
      const like  = message.likes.find(like => like.user.user_id === user_id)
      this.props.unLikeChat(message.message_id, like.like_id)
    } else {
      this.reactChat(message.message_id, 'good_job');
    }
  }

  render() {
    const { isMobile, viewportHeight, isKeyboardVisible } = this.state;
    const {
      t,
      ui,
      isFetchFailed,
      isFetching,
      hasMore,
      chatRoom,
      chatRoomName,
      chatMessages,
      user,
      readMessage,
      otherMembers,
      name,
      messageData,
      likeConfig,
    } = this.props

    const rightSidePageStyle = isMobile ? {
      overflow: 'hidden',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    } : {};

    const containerStyle = isMobile ? {
      display: 'flex',
      height: isKeyboardVisible ? 
        `${viewportHeight - 45}px` : 
        'calc(100vh - 135px)',
      flexDirection: 'column',
      position: 'relative',
      flex: 1,
      minHeight: 0
    } : {
      display: 'flex',
      height: 'calc(100vh - 135px)',
      flexDirection: 'column'
    };

    const scrollDivStyle = isMobile ? {
      flexGrow: 1,
      overflow: 'auto',
      background: '#BAD3FF',
      WebkitOverflowScrolling: 'touch',
      paddingBottom: isKeyboardVisible ? '10px' : '60px',
      maxHeight: '100%'
    } : {
      flexGrow: 1,
      overflow: 'auto',
      background: '#BAD3FF'
    };

    const formContainerStyle = isMobile ? {
      position: 'sticky',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'white',
      zIndex: 1000,
      borderTop: '1px solid #e0e0e0',
      paddingBottom: isKeyboardVisible ? 0 : 'env(safe-area-inset-bottom)'
    } : {};
    const sequence = chatRoom && chatRoom.sequence_id ? ` (${chatRoom.sequence_id})` : ''
    return (
      <div ref={(c)=> this.component = c} style={{ height: '100%'}}>
      {ui.openPdf && <PdfPreviewDialog file={ui.pdf} open={ui.openPdf} onClose={this.closePdf} t={t} />}
      {ui.openAlbum && <ChatAlbum chatRoom={chatRoom} open={ui.openAlbum} closeAlbum={this.closeAlbum} openPdf={this.openPdf} t={t}/>}
      <RightSidePage title={ (!chatRoom || !chatRoom.name) && t('label:ユーザとのチャット', { name }) + sequence || chatRoom.name }
          style={rightSidePageStyle}
          image={otherMembers && otherMembers.length == 1 && otherMembers[0].icon_image.thumb_url || undefined}
          members={otherMembers && otherMembers.length > 1 && otherMembers || undefined}
          icon={!otherMembers || otherMembers.length != 1 && "people"}
          icon_image={chatRoom && chatRoom.icon_image ? chatRoom.icon_image : undefined}
          rightAction={[
            <IconButton icon='photo_library' key='menu'
              onClick={()=> {
                chatRoom && this.openAlbum()
            }} />,
            <IconButton icon='more_vert' key='more'
              onClick={()=> {
                chatRoom && this.setState({ [chatRoom.chat_room_id]: true } || undefined)
            }} />
          ]} >
        {chatRoom &&
          <ChatRoomSettingsPage key="page"
            open={this.state[chatRoom.chat_room_id] || false}
            chatRoom={chatRoom}
            chatRoomName={chatRoomName}
            user={user}
            onClose={()=> this.setState({ [chatRoom.chat_room_id]: false })} />
        }
        {!isFetchFailed &&
          <div style={containerStyle}>
            <div style={scrollDivStyle} ref={(c)=> this.scrollDiv = c}>
              <InfiniteScroll isReverse
                  pageStart={0}
                  initialLoad={false}
                  loadMore={this.fetchMessages}
                  hasMore={hasMore && !isFetchFailed}
                  loaderHeight={0}
                  loader={isFetching && <Loading />}
                  useWindow={false} >
                {_.reduceRight(messageData, (result, item)=> result.concat(
                  item.message && <ChatMessageItem
                      withName={item.withName}
                      key={item.message_id}
                      message={item.message}
                      readMessage={readMessage}
                      user={user}
                      chatRoomMember={chatRoom && chatRoom.members}
                      individualChatRoom={ui.individualChatRoom}
                      direction={item.message.user.user_id == user.user_id}
                      deleteChatMessage={this.deleteChatMessage}
                      chatPageWidth={this.state.clientWidth}
                      openPdf={this.openPdf}
                      openDoc={this.openDoc}
                      likeConfig={likeConfig}
                      {...(item.message.user.user_id !== user.user_id && { 
                        reactionChat: () => this.reactionChat(item.message, user.user_id)
                      })}
                      /> ||
                  <div key={item.message_id} className={chatMessageTheme.divider}>
                    <span className={chatMessageTheme.span} >
                      {item.created_at.format('lll')}
                    </span>
                  </div>
                ), [])}
                {!isFetching && (!chatMessages || chatMessages.length == 0) &&
                  <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:メッセージがありません')}</div>
                }
              </InfiniteScroll>
            </div>

            {chatRoom && !chatRoom.obsoleted && 
              <div style={formContainerStyle}>
                <ChatMessageForm chatRoom={chatRoom} />
              </div>
            }
            {chatRoom && chatRoom.obsoleted && t('label:このチャットは終了しました')}
          </div>
        }
        {isFetchFailed &&
          <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:メッセージの取得に失敗しました')}</div>
        }
      </RightSidePage>
      </div>
    )
  }
}

export const RawChatMessagesPage = ChatMessagesPage
export default connect(ChatMessagesPage)




// WEBPACK FOOTER //
// ./src/web/components/chat-messages-page.jsx